<div role="list">
  @for (organization of organizations; track organization; let i = $index) {
    <button class="button-container button-unclickable" i18n role="listitem">
      <span class="button-text">
        Organization Name: <b>{{ organization.organizationName }}</b><br>
        <mat-icon class="org-verify-icon">check_circle</mat-icon> Verified: {{ organization.oidvTimestamp | date:'fullDate':'UTC':'en-US' }}
      </span>
      @if (organization.organizationMediaData ) {
        <img [src]="organization.organizationMediaData.imageUrl" height="30px" alt="">
      } @else {
        <mat-icon class="org-logo-default">people</mat-icon>
      }
    </button>
  }
</div>